module.exports = __webpack_public_path__ + "img/wallet.c14f2959.svg";